import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useFeatureFlags } from 'libs.flags.react';
import { useLocalizeMessage } from 'libs.nucleus';
import { PageHeader, PageWrapper, useBooleanState } from 'libs.react';
import { ConsentArchiveBanner } from '../../components/consent_archive_banner/consent_archive_banner.component';
import { ParticipantFormModal } from '../../components/participant_form/participant_form_modal.component';
import { ParticipantsTable } from '../../components/participants_table/participants_table.component';
import { SITE_FEATURE_FLAGS } from '../../constants/feature_flags.constants';
import { SiteContext } from '../../contexts/site';
import { getArchiveBannerSiteId } from '../../helpers/archive_banner.helpers';
import { useArchiveBannerSummary } from '../../hooks/use_archive_banner_summary';
import { useCurrentEnvironment } from '../../hooks/use_current_environment';
import { useLumosAuth } from '../../hooks/use_lumos_auth';
import { LUMOS_PERMISSIONS } from '../../types/permissions.types';
export const ParticipantsList = () => {
    const translate = useLocalizeMessage();
    const { isFeatureEnabled } = useFeatureFlags();
    const isDocGenEconsentEnabled = isFeatureEnabled(SITE_FEATURE_FLAGS.DOC_GEN_ECONSENT);
    const { environment } = useCurrentEnvironment();
    const { site } = useContext(SiteContext);
    const archiveSiteId = getArchiveBannerSiteId(environment, site?._id);
    const { data: archiveSummary } = useArchiveBannerSummary({
        environment,
        siteId: archiveSiteId,
        enabled: isDocGenEconsentEnabled,
    });
    const [isParticipantFormOpen, setParticipantFormOpen, setParticipantFormClose] = useBooleanState();
    const { isUserPermitted } = useLumosAuth();
    const headerOptions = [];
    if (isUserPermitted(LUMOS_PERMISSIONS.PARTICIPANTS_CREATE)) {
        headerOptions.push({
            name: translate('action.participant.create'),
            onClick: setParticipantFormOpen,
            variant: 'primary',
            dataTestId: 'create-participant-button',
        });
    }
    const siteNumber = site?.c_number?.trim();
    const siteCity = site?.c_site_address?.c_city?.trim();
    const siteName = site?.c_name?.trim();
    const siteSubtitleLeft = [siteNumber ? `${translate('generic.site')} ${siteNumber}` : '', siteCity]
        .filter(Boolean)
        .join(' — ');
    const siteSubtitle = [siteSubtitleLeft, siteName].filter(Boolean).join('  ·  ') || undefined;
    return (_jsxs(PageWrapper, { children: [_jsx(PageHeader, { title: translate('generic.participants'), subtitle: siteSubtitle, options: headerOptions, LinkComponent: Link }), isDocGenEconsentEnabled ? (_jsx(ConsentArchiveBanner, { environmentId: environment?.id, siteId: archiveSiteId, summary: archiveSummary }, archiveSiteId || 'consent-archive-banner')) : null, _jsx(ParticipantFormModal, { isModalOpen: isParticipantFormOpen, onClose: setParticipantFormClose }), _jsx(ParticipantsTable, {})] }));
};
